import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/(main)/[slug]/[model]/ProductDetailPageClient.tsx");
